var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.row.Name)?[(_vm.row.Name)?_c('FormButton',{attrs:{"size":"small","type":"text","href":_vm.row.Name,"tag":"a","left-icon":"md-eye"},on:{"click":() => _vm.link()}},[_vm._v("View")]):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }